import { UseFormRegisterReturn } from "react-hook-form/dist/types";
import * as S from "../Input.style";

interface SelectProps {
  width?: string;
  size: string;
  layout: string;
  label?: string;
  themeType?: string;
  placeholder?: string;
  options: any;
  register?: UseFormRegisterReturn;
  onChange?: any;
  value?: any;
  disable?: any;
}

export const InputSelect: React.FC<SelectProps> = ({
  width,
  layout,
  size,
  options,
  label,
  themeType,
  placeholder,
  register,
  onChange,
  value,
  disable,
}) => {
  return (
    <S.InputCommon
      themeType={themeType}
      layout={layout}
      size={size}
      width={width}
    >
      <label>
        {label && label}
        <select
          {...register}
          onChange={onChange}
          value={value}
          disabled={disable}
        >
          {placeholder && <option>{placeholder}</option>}
          {options?.map((option: any, idx: number) => {
            return (
              <option key={idx} value={option.value}>
                {option.value}
              </option>
            );
          })}
        </select>
      </label>
    </S.InputCommon>
  );
};
